import React from 'react'
import styled from 'styled-components'

const FacesWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
`

const FaceImage = styled.img`
  width: 6rem;
  height: 6rem;
  object-fit: cover;
  border-radius: 50%;
`

const SimilarityScore = styled.div`
  display: flex;
  position: absolute;
  z-index: 10;
  color: white;
  font-size: 1.15rem;
  font-weight: normal;
  background: ${({ isFailed }) => (isFailed ? 'red' : '#3ac83a')};
  border-radius: 50%;
  width: 2.75rem;
  height: 2.75rem;
  justify-content: center;
  align-items: center;
`

const FaceComparisonResult = ({ imageLeft, imageRight, similarity }) => {
  const isFailed = similarity < 90

  return (
    <FacesWrapper>
      <FaceImage src={imageLeft} alt="Face 1" />
      <FaceImage src={imageRight} alt="Face 2" />
      <SimilarityScore isFailed={isFailed}>{similarity}%</SimilarityScore>
    </FacesWrapper>
  )
}

export default FaceComparisonResult
